import React from "react";
import { Braces } from "lucide-react";

/* ===================== COMPONENTS ===================== */
import { TableSkeleton } from "../Skeleton/StatsSkeleton";

/* ===================== STYLES ===================== */
import styles from "./RequestBodyFormate.module.scss";

/**
 * RequestBodyFormate
 * ------------------
 * Displays raw request_parameter JSON
 * using the same UI container as RequestBodyParams
 */
const RequestBodyFormate = ({ request }) => {
  const loading = !request || Object.keys(request).length === 0;

  return (
    <div className={styles["admin-req-body-formate__card"]}>
      {/* HEADER */}
      <div className={styles["admin-req-body-formate__header"]}>
        <div className={styles["admin-req-body-formate__icon-wrapper"]}>
          <Braces size={18} strokeWidth={2.5} />
        </div>
        <h3 className={styles["admin-req-body-formate__title"]}>
          Request Body (JSON)
        </h3>
      </div>

      {/* CODE BLOCK */}
      <div className={styles["admin-req-body-formate__code-wrapper"]}>
        <pre className={styles["admin-req-body-formate__pre"]}>
          {loading ? (
            <TableSkeleton columns={1} rows={3} />
          ) : (
            JSON.stringify(request || {}, null, 2)
          )}
        </pre>
      </div>
    </div>
  );
};

export default RequestBodyFormate;
